(function() {
  'use strict';

  var ROOT_SELECTOR = '[data-miralova-options]';
  var NATIVE_SURCHARGE_PREFIX = 'Surcharge ';

  function selectedSurcharge(select) {
    var option = select.options[select.selectedIndex];
    return option ? Number(option.getAttribute('data-surcharge') || 0) : 0;
  }

  function calculateSurcharge(selects) {
    return Array.prototype.reduce.call(selects, function(total, select) {
      return total + selectedSurcharge(select);
    }, 0);
  }

  function selectedSize(root) {
    var size = root.querySelector('[data-option-label="Size"]');
    if (size) return size.value;
    return root.querySelector('[data-miralova-custom-only]') ? 'Custom' : '';
  }

  function setMeasurementsVisible(root, visible) {
    var panel = root.querySelector('[data-miralova-measurements]');
    if (!panel) return;

    panel.hidden = !visible;
    Array.prototype.forEach.call(
      panel.querySelectorAll('[data-custom-measurement]'),
      function(input) {
        input.disabled = !visible;
      }
    );
  }

  function setError(root, message) {
    var error = root.querySelector('[data-miralova-options-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function updateSurchargeProperty(root, surcharge) {
    var property = root.querySelector('[data-miralova-surcharge-property]');
    if (property) property.value = '$' + surcharge.toFixed(2);

    var total = root.querySelector('[data-miralova-options-total]');
    if (total) total.textContent = 'Customization: +$' + surcharge.toFixed(2);
  }

  function nativeSurchargeSelector(form) {
    return form.querySelector('[data-miralova-surcharge-selector]');
  }

  function setNativeSurchargeVariant(form, surcharge) {
    var selector = nativeSurchargeSelector(form);

    if (!selector) return surcharge === 0;

    var targetValue = NATIVE_SURCHARGE_PREFIX + surcharge;
    var hasTarget = Array.prototype.some.call(selector.options, function(option) {
      return option.value === targetValue;
    });

    if (!hasTarget) return false;

    if (selector.value !== targetValue) {
      selector.value = targetValue;
      selector.dispatchEvent(new Event('change', { bubbles: true }));
    }

    return true;
  }

  function validate(root) {
    var invalid = Array.prototype.find.call(
      root.querySelectorAll('select[required]:not([disabled]), input[required]:not([disabled])'),
      function(input) {
        return !input.value || (input.type === 'number' && Number(input.value) <= 0);
      }
    );

    if (!invalid) return true;

    invalid.focus();
    setError(root, 'Please complete all required product options.');
    return false;
  }

  function update(root) {
    var form = root.closest('form');
    var selects = root.querySelectorAll('[data-miralova-option]');
    var surcharge = calculateSurcharge(selects);
    var hasVariant = setNativeSurchargeVariant(form, surcharge);
    var addButton = form.querySelector('[data-add-to-cart]');

    setMeasurementsVisible(root, selectedSize(root) === 'Custom');
    updateSurchargeProperty(root, surcharge);

    if (!hasVariant) {
      setError(root, 'This customization price is not configured yet.');
      if (addButton) addButton.setAttribute('aria-disabled', 'true');
      return;
    }

    if (addButton) addButton.removeAttribute('aria-disabled');
    setError(root, '');
  }

  function init(root) {
    var form = root.closest('form');
    if (!form) return;

    Array.prototype.forEach.call(
      root.querySelectorAll('[data-miralova-option]'),
      function(select) {
        select.addEventListener('change', function() {
          update(root);
        });
      }
    );

    form.addEventListener(
      'submit',
      function(event) {
        update(root);
        if (!validate(root) || !setNativeSurchargeVariant(form, calculateSurcharge(root.querySelectorAll('[data-miralova-option]')))) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      },
      true
    );

    update(root);
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll(ROOT_SELECTOR), init);
  }

  window.MiralovaProductOptions = {
    calculateSurcharge: calculateSurcharge,
    init: init,
    update: update
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
